import { useEffect, useState } from "react";
import { APIHelper } from "../Apis/APIHelper";
import { AddressChangeContactConst } from "../Components/AddressChangeContactConst";
import { error, success, warning } from "../Components/custom-toast/CustomToast";
import _ from 'lodash';
import { t } from "i18next";
import * as Service from "./service";

//load Init(get session)
export const loadInit = async (setObjectDto, setLoading) => {
    const body = {
        "mesgId": "CUSTOMER_MESG_00000009",
        "obj": {}
    }
    //GW test
    const session = sessionStorage.getItem("sessionId") !== null && sessionStorage.getItem("sessionId") !== "undefined" ? JSON.parse(sessionStorage.getItem("sessionId")) : null;
    if (session === null) {
        const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
        const data = await APIHelper.postDataCustomer(body, bearerToken);
        if (data === undefined) return undefined
        if (data.code === "1") {
            const jsonData = JSON.parse(data.jsonData);
            if (jsonData !== undefined && jsonData !== "undefined" && jsonData !== null && jsonData !== '') {
                sessionStorage.setItem("sessionId", JSON.stringify(jsonData.sessionId));
                sessionStorage.setItem("objectDto", JSON.stringify(jsonData));
                setObjectDto(jsonData);
            } else {
                return alert(t("erroraccesspage"))
            }
        } else {
            return error(t("erroraccesspage"));
        }
    } else {
        const objSession = JSON.parse(sessionStorage.getItem("objectDto"));
        if (_.isEmpty(objSession)) {
            return setObjectDto({ checked: 0, saved: 0 })
        } else {
            if (objSession.saved === 1) {
                HandleClose(setObjectDto, setLoading);
            } else {
                setObjectDto(JSON.parse(sessionStorage.getItem("objectDto")));
            }
        }
    }
}

//get OTP
export const HandleSendSMSToken = async (idNumber, phone, policyNo, setOtpTitle, setState, setValidate, setLoading) => {
    // //validate isNull
    // if (idNumber !== "" && phone !== "" && policyNo !== "") {
    //     const body = {
    //         "mesgId": "CUSTOMER_MESG_00000010",
    //         "obj": {
    //             poNumber: policyNo,
    //             poIdNumber: idNumber,
    //             phone: phone,
    //         }
    //     };
    //     const data = await APIHelper.postData(body);
    //     //uat
    //     if (data === undefined || data.code === "Error 500" || data.code === "") {
    //         error(t("errormessagegetdata"));
    //     } else if (data.code === "2") {
    //         error(data.message);
    //     } else if (data.message === "0") {
    //         error(t("errormessagenotfoundpolicy"));
    //     } else if (data.message === "1") {
    //         error(t("errormessagenotfoundphone"));
    //     } else if (data.message === "2") {
    //         error(t("errormessagepolicyexpired"));
    //     } else if (data.message === "ERR") {
    //         // console.log("Error at HandleSendSMSToken")
    //     } else {
    //         setOtpTitle(data.message);
    //         setState(true);
    //         setLoading(false);
    //         return setValidate(false);
    //     }
    // }
    // setValidate(true);
    // setState(false);
    // return setLoading(false);

    //test
    const body = {
        "mesgId": "CUSTOMER_MESG_00000010",
        "obj": {
            poNumber: policyNo,
            poIdNumber: idNumber,
            phone: phone,
        }
    };
    const data = await APIHelper.postData(body);
    setOtpTitle(data.message);
    setState(true);
    setLoading(false);
    return setValidate(false);
}

//verify OTP
export const ValidateOtp = (token, setValidate) => {
    var check = true;
    if (token.length !== 6 && token !== "") {
        error(t("errormessagewrongformatotp"));
        check = false;
    } else if (token === '' || token === undefined || token === null) {
        warning(t("errormessagemissingfield"))
        check = false;
    }
    setValidate(!check);
    return check;
}
export const HandleVerifyOtp = async (idNumber, phone, policyNo, token, otpTitle, setLoading, count, setCount, setState, setObjectDto, setValidate, setReset) => {
    if (count < 6 && count !== 5) {//send otp < 5 times
        if (ValidateOtp(token, setValidate)) {// valid form token
            setLoading(true);
            const body = {
                "mesgId": "CUSTOMER_MESG_00000011",
                "obj": {
                    poNumber: policyNo,
                    poIdNumber: idNumber,
                    phone: phone,
                    token: token,
                    otpTitle: otpTitle,
                }
            };
            const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
            const data = await APIHelper.postDataCustomer(body, bearerToken);
            if (data.code === "1") {
                const jsonData = JSON.parse(data.jsonData);
                if (jsonData === "ERR") {
                    // console.log("Error at HandleVerifyOtp");
                } else {
                    if (jsonData.checked === 1) {
                        //if check otp sms ok
                        document.getElementById("invalidOTP").style.display = "none";
                        document.getElementById("otpDiv").style.display = "none";
                        setState(false);
                        setObjectDto(jsonData);
                        sessionStorage.setItem("objectDto", JSON.stringify(jsonData));
                        setReset(true);
                    } else if (jsonData.checked === 0) {
                        document.getElementById("otpDiv").style.display = "block";
                        document.getElementById("policyDiv").style.display = "none";
                        document.getElementById("invalidOTP").style.display = "block";
                        setCount(count => count + 1);
                    }
                    setLoading(false);
                    return true;
                }
                setLoading(false);
                return false;
            }
        }
    } else {
        alert(t("messageotpinvalidmany"));
        setCount(0);
        setLoading(true);
        setState(false);
        setReset(true);
        return HandleClose(setObjectDto, setLoading);
    }
    return setCount(count => count + 1);
}

export const HandleVerifyToken = async (poNumber, setObjectDto, setLoading) => {
    const idNumber = JSON.parse(localStorage.getItem('aaa')).poIdNumber;
    if (poNumber !== "") {
        const body = {
            "mesgId": "CUSTOMER_MESG_00000011",
            "obj": {
                phone: "1111111111",
                token: "123456",
                poNumber: poNumber,
                poIdNumber: idNumber,
            }
        };
        const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
        const data = await APIHelper.postDataCustomer(body, bearerToken);
        if (data !== 'ERR') {
            if (data.code === "1") {
                const jsonData = JSON.parse(data.jsonData);
                // if (jsonData.verifyOtp !== 0) {
                //     if (objectDto.verifyOtp >= 4) {
                //         alert(t("errorcountotp"));
                //         setObjectDto({ ...objectDto, verifyOtp: 0, policyChecked: 0 });
                //         document.getElementById("otpDiv").style.display = "none";
                //         document.getElementById("policyDiv").style.display = "block";
                //         setToken('');
                //     } else {
                //         setObjectDto({ ...objectDto, verifyOtp: objectDto.verifyOtp + 1 });
                //         setToken('');
                //     }
                // } else {
                setObjectDto(jsonData);
                // }
            }
        }
    } else {
        warning("NHẬP DÔ");
    }
    setLoading(false);
}

//close button
export const HandleClose = async (setObjectDto, setLoading) => {
    const body = {
        "mesgId": "CUSTOMER_MESG_00000017",
        "obj": {}
    }
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    if (data.code === "1") {
        sessionStorage.removeItem("sessionId");
        sessionStorage.removeItem("objectDto");
        loadInit(setObjectDto, setLoading);
        window.scrollTo(0, 0);
    } else {
        error(t("erroraccesspage"))
    }

    setLoading(false);
}

export const ManagePosRequest = (objectDto, setObjectDto, loading, setLoading, listFile) => {
    useEffect(() => {
        loadInit(setObjectDto, setLoading);
    }, []);

    useEffect(() => {
        if (objectDto !== undefined) {
            if (objectDto.changeFrequencyChecked === 0) {
                var check = true;
                objectDto.frequency = 0;
                while (check === true) {
                    var flag = false;
                    listFile.map((item) => {
                        if (item.documentCode === "004") {
                            flag = true;
                            return listFile.splice(listFile.indexOf(item), 1);
                        }
                    });
                    if (flag === false) check = false;
                }
            }
            if (objectDto.changePersonalChecked === 0) {
                var check = true;
                objectDto.changePersonalDetail = [];
                while (check === true) {
                    var flag = false;
                    listFile.map((item) => {
                        if (item.documentCode === "003") {
                            flag = true;
                            return listFile.splice(listFile.indexOf(item), 1);
                        }
                    });
                    if (flag === false) check = false;
                }
            }
            if (objectDto.changeContactChecked === 0) {
                objectDto.changeContactDetail = [AddressChangeContactConst, AddressChangeContactConst, AddressChangeContactConst];
            }
        } else {
            loadInit(setObjectDto, setLoading);
        }
    }, [objectDto]);

    useEffect(() => {
        if (objectDto === undefined || objectDto === null || objectDto === '' || loading === true) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
            sessionStorage.setItem("objectDto", JSON.stringify(objectDto));
        }
    }, [objectDto, loading]);
}

//process checkbox
export const ProcessCheckBox = async (objectDto, setObjectDto, setLoading) => {
    const sessionId = JSON.parse(sessionStorage.getItem("sessionId"));
    console.log(objectDto);
    const body = {
        "mesgId": "CUSTOMER_MESG_00000018",
        "obj":
        {
            applyAll: objectDto.applyAll, applyFor: objectDto.applyFor, changeAddressContactChecked: objectDto.changeAddressContactChecked,
            changeAddressResidentChecked: objectDto.changeAddressResidentChecked, changeContactChecked: objectDto.changeContactChecked,
            changePhoneChecked: objectDto.changePhoneChecked,
            changeContactDetail: objectDto.changeContactDetail, changeFrequencyChecked: objectDto.changeFrequencyChecked,
            changePersonalChecked: objectDto.changePersonalChecked, changePersonalDetail: objectDto.changePersonalDetail, checked: objectDto.checked,
            emailNotChecked: objectDto.emailNotChecked, email: objectDto.email, frequency: objectDto.frequency, idNumber: objectDto.idNumber, laName: objectDto.laName,
            otpTitle: objectDto.otpTitle, phone: objectDto.phone, poName: objectDto.poName, policyNo: objectDto.policyNo, saved: objectDto.saved,
            reasonDesc: objectDto.reasonDesc, reasonOther: objectDto.reasonOther, sessionId: sessionId, status: objectDto.status, termChecked: objectDto.termChecked
        }
    }
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    console.log(data);
    if (data.code === "1") {
        const jsonData = JSON.parse(data.jsonData);
        if (jsonData === "ERR") {
            // console.log("Error at ProcessCheckBox")
        } else {
            if ((jsonData.changeAddressContactChecked === 1 || jsonData.changeAddressResidentChecked === 1 || jsonData.changePhoneChecked === 1) && jsonData.changeContactDetail.length < 3) {
                const list = jsonData.changeContactDetail;
                var phone = null;
                var contact = null;
                var resident = null;
                list.map((item) => {
                    if (item.type === "PHONE_CHANGE") {
                        phone = item;
                    }
                    if (item.type === "CONTACT_INFO") {
                        contact = item;
                    }
                    if (item.type === "RESIDENT_INFO") {
                        resident = item;
                    }
                });
                jsonData.changeContactDetail = [contact ?? AddressChangeContactConst, resident ?? AddressChangeContactConst, phone ?? AddressChangeContactConst]
            }
            sessionStorage.setItem("objectDto", data.jsonData);
            setObjectDto(jsonData);
        }
    }
    setLoading(false);
}

//Handle Info Checkbox
export const HandleInfoCheckbox = (objectDto, setObjectDto, typeInfo, setLoading, event, value) => {
    const changeObject = typeInfo === 1 ?
        //contact
        {
            ...objectDto, changeContactDetail: [], reasonDesc: "", applyAll: 0, applyFor: 0, changeAddressContactChecked: 0,
            changeAddressResidentChecked: 0, changePhoneChecked: 0, changeContactChecked: event.target.checked === true ? 1 : 0
        }
        : typeInfo === 2 ?
            //personal
            { ...objectDto, changePersonalChecked: event.target.checked === true ? 1 : 0 }
            : (typeInfo === 3) ?
                { ...objectDto, changeFrequencyChecked: event.target.checked === true ? 1 : 0 }
                :
                //error
                null;
    if (changeObject === null) return alert(t("errormessageaction"));
    ProcessCheckBox(changeObject, setObjectDto, setLoading);
}

//Fetch Province
export const FetchProvinceList = async (set, setLoading) => {
    const body = {
        mesgId: "CUSTOMER_MESG_00000006",
        obj: {},
    }
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    setLoading(false);
    if (data.code === "1") {
        const jsonData = JSON.parse(data.jsonData);
        if (jsonData !== "ERR") {
            return set(jsonData);
        } else {
            // console.log("Error at FetchProvinceList");
            return "ERR";
        }
    } else {
        error(t("erroraccesspage"))
    }
}

export const FetchDistrictList = async (code, set, setLoading) => {
    const body = {
        mesgId: "CUSTOMER_MESG_00000007",
        obj: { provinceCode: code }
    }
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    setLoading(false);
    if (data.code === "1") {
        const jsonData = JSON.parse(data.jsonData);
        if (jsonData === "ERR") {
            // console.log('ERROR at FetchDistrictList');
        } else {
            return set(jsonData);
        }
    } else {
        error(t("erroraccesspage"));
    }
}

export const FetchWardList = async (code, set, setLoading) => {
    const body = {
        mesgId: "CUSTOMER_MESG_00000008",
        obj: { districtCode: code }
    }
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    setLoading(false);
    if (data.code === "1") {
        const jsonData = JSON.parse(data.jsonData);
        if (jsonData === "ERR") {
            // console.log("ERROR at FetchWardList");
        } else {
            return set(jsonData);
        }
    } else {
        error(t("erroraccesspage"));
    }
}

export const ValidateSearchInfoCheckbox = (objectDto, setValidate) => {
    if (objectDto.emailNotChecked === 0) {
        if (objectDto.email === '' || objectDto.email === undefined) {
            warning(t("errormessagemissingfield"));
            setValidate(true);
            return false;
        } else {
            setValidate(false);
            if (Service.ValidateEmail(objectDto.email)) {
                setValidate(false);
                return true;
            }
            else {
                warning(t("errormessageinvalidemail"));
                return false;
            }
        }
    } else {
        setValidate(false);
        return true;
    }
}

//Get - Reset Place 
export const CheckExistPlaceData = (objectDto, setObjectDto, addressContactChecked, setProvinceContact, setDistrictContact,
    setWardContact, addressResidentChecked, setProvinceResident, setDistrictResident, setWardResident, setLoading) => {
    useEffect(() => {
        if (objectDto.changeContactDetail.length === 0) {
            setObjectDto({ ...objectDto, changeContactDetail: [AddressChangeContactConst, AddressChangeContactConst, AddressChangeContactConst] });
        }
        if (addressContactChecked === 1) {
            FetchProvinceList(setProvinceContact, setLoading);
            if (objectDto.changeContactDetail[0] !== undefined) { //fill data | if data api exist code <=> map data
                if (objectDto.changeContactDetail[0].provinceCode !== undefined && objectDto.changeContactDetail[0].provinceCode !== "") {
                    FetchDistrictList(objectDto.changeContactDetail[0].provinceCode, setDistrictContact, setLoading);
                }
                if (objectDto.changeContactDetail[0].districtCode !== undefined && objectDto.changeContactDetail[0].districtCode !== "") {
                    FetchWardList(objectDto.changeContactDetail[0].districtCode, setWardContact, setLoading);
                }
            }
        }
        if (addressResidentChecked === 1) {
            FetchProvinceList(setProvinceResident, setLoading);
            if (objectDto.changeContactDetail[1] !== undefined) { //fill data | if data api exist code <=> map data
                if (objectDto.changeContactDetail[1].provinceCode !== undefined && objectDto.changeContactDetail[1].provinceCode !== "") {
                    FetchDistrictList(objectDto.changeContactDetail[1].provinceCode, setDistrictResident, setLoading);
                }
                if (objectDto.changeContactDetail[1].districtCode !== undefined && objectDto.changeContactDetail[1].districtCode !== "") {
                    FetchWardList(objectDto.changeContactDetail[1].districtCode, setWardResident, setLoading);
                }
            }
        }
    }, [addressContactChecked, addressResidentChecked])

    useEffect(() => {
        if (objectDto.changeContactChecked === 1) {
            if (objectDto.changeContactDetail.length === 0) {
                setObjectDto({ ...objectDto, changeContactDetail: [AddressChangeContactConst, AddressChangeContactConst, AddressChangeContactConst] });
            }
        }
    }, [objectDto]);
}

// get name by code
export const getNamePlaceByCode = (list, code) => {
    var item = null;
    if (code !== null && code !== "" && list.length !== 0) {
        list.find((element) => {
            if (element.code === code) return item = element.name;
        })
    }
    return item;
}

//change format date
export const FormatDate = (date) => {
    const formatDate = date.split('-');
    return formatDate[2] + '/' + formatDate[1] + '/' + formatDate[0];
}

//handle change event value
export const handleChangeEventValue = (event, set) => {
    set(event.target.value);
};

//handle change event textContent
export const handleChangeEventTextContent = (event, set) => {
    set(event.target.textContent);
}

//handle versa value
export const HandleVersa = (value, set) => {
    set(!value)
}

//validate personal field
export const ValidatePersonal = (birth, id, typeId, gender, fullname, dateId, placeId) => {
    var check = false;
    if (birth === '' || id === '' || typeId === '' || gender === '' || fullname === '' || dateId === '' || placeId === '' ||
        birth === null || id === null || typeId === null || gender === null || fullname === null || dateId === null || placeId === null) {
        warning(t("errormessagerequirefield"));
        check = true;
    }
    return check;
}

//ADD Personal List
export const ChangePersonalList = async (objectDto, setObjectDto, changeFullName, changeGender, birthDate, changeIdnumber, idType, idDate, changeIdplace, transactionTypeSub, type) => {
    var date = new Date(birthDate.$d);
    const birth = date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
    var date = new Date(idDate.$d);
    const dateId = date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
    const typePersonal = type === "radioLAInfo" ? "CONTACT_INFO_LA" : type === "radioBenInfo" ? "CONTACT_INFO_BEF" : "CONTACT_INFO_PO";
    const body = {
        "mesgId": "CUSTOMER_MESG_00000012",
        "obj": {
            fullname: changeFullName, gender: changeGender, dayOfBirth: birth, identityNumber: changeIdnumber, identityType: idType, identityDate: dateId,
            identityPlace: changeIdplace, transactionTypeSub: transactionTypeSub, type: typePersonal,
        }
    };

    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    if (data.code === "1") {
        const jsonData = JSON.parse(data.jsonData);
        if (jsonData === "ERR") {
            // console.log("ERROR at ChangePersonalList");
        } else {
            var temp = [];
            if (objectDto.changePersonalDetail !== undefined && objectDto.changePersonalDetail.length !== 0) {
                temp = objectDto.changePersonalDetail;
                temp.push(jsonData.changePersonalDetail[0]);
                setObjectDto({ ...objectDto, changePersonalDetail: temp });
            } else {
                setObjectDto({ ...objectDto, changePersonalDetail: jsonData.changePersonalDetail });
            }
        }
    }
}

//Remove Personal List
export const RemovePersonal = async (objectDto, setObjectDto, index) => {
    //     const body = {
    //         "mesgId": "CUSTOMER_MESG_00000013",
    //         "obj": {
    //             index: objectDto.changePersonalDetail.indexOf(index),
    //         }
    //     };
    //     const data = await APIHelper.postData(body);
    //     if (data.code === "1") {
    //         const jsonData = JSON.parse(data.jsonData);
    //         if (jsonData === "ERR") {
    //             console.log("ERROR at RemovePersonal");
    //         } else {
    //             setObjectDto(jsonData);
    //             sessionStorage.setItem("objectDto", JSON.stringify(jsonData));
    //         }
    //     } else {
    //         error("ERROR 500");
    //     }
    var list = [];
    list = objectDto.changePersonalDetail;
    list.splice(index, 1);
    setObjectDto({ ...objectDto, changePersonalDetail: list });
}

//Reset Object DTO
export const Reset = (objectDto, setObjectDto) => {
    setObjectDto({
        ...objectDto, changeContactChecked: 0, changePersonalChecked: 0, changeFrequencyChecked: 0, changeAddressContactChecked: 0, changeAddressResidentChecked: 0,
        changeContactDetail: [], changePersonalDetail: [], fileList: [], frequency: 0, saved: 0, status: 0, termChecked: 0, checked: 0, emailNotChecked: 0, applyAll: 0,
        applyFor: 0
    })
}

//Handle delete img in UI
export function HandleDeleteFile(listFile, setListFile, index, objectDto, setObjectDto) {
    var datalist = [];
    listFile.map((item) => {
        if (listFile.indexOf(item) !== index) datalist.push(item);
        return datalist;
    });
    setObjectDto({ ...objectDto, fileList: datalist });
    return setListFile(datalist);
}

//convert img to base64
const base64Img = (img) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(img);
        reader.onload = () => {
            resolve(reader.result);
        };
        reader.onerror = reject;
    });
};

//get responsive
export const getSizeWindows = () => {
    const [windowSize, setWindowSize] = useState([window.innerWidth, window.innerHeight]);
    useEffect(() => {
        const handleWindowResize = () => {
            setWindowSize([window.innerWidth, window.innerHeight]);
        };
        window.addEventListener('resize', handleWindowResize);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, [window]);
    return windowSize;
}

//handle Upload img to UI
//  export const HandleFileChange = (e, listFile, setListFile, setLoading, type, objectDto, setObjectDto) => {
//     setLoading(true);
//     const list = listFile;
//     const files = e.target.files;
//     var check = true;
//     Array.from(files).forEach(file => {
//         base64Img(file).then((value) => {
//             const dataPush = {
//                 base64: value,
//                 documentCode: type === 1 ? "003" : "004",
//                 fileName: Service.toNonAccentVietnamese(file.name),
//                 timestamp: Date.now()
//             }
//             list.push(dataPush);
//         }).finally(() => {
//             setListFile(list);
//             setObjectDto({ ...objectDto, fileList: listFile })
//             sessionStorage.setItem('objectDto', JSON.stringify(objectDto));
//             count = count + 1;
//         }).catch(() => check = false);
//     })
//     if (check)
//         success(files.length + t("messagesuccessuploadimage"));
//     else
//         error("Tải hình ảnh không thành công!!!");
//     setLoading(false);
// }

export const HandleFileChange = async (e, listFile, setListFile, setLoading, type, objectDto, setObjectDto) => {
    setLoading(true);
    const files = e.target.files;
    const list = [...listFile];
    let successCount = 0;
    try {
        await Promise.all(Array.from(files).map(async (file) => {
            try {
                const value = await base64Img(file);
                const dataPush = {
                    base64: value,
                    documentCode: type === 0 ? "003" : type === 1 ? "004" : "005",
                    fileName: Service.toNonAccentVietnamese(file.name),
                    timestamp: Date.now()
                };
                list.push(dataPush);
                successCount++;
            } catch (error) {
                console.error("Error uploading file:", file.name, error);
                throw error;
            }
        }));
        setListFile(list);
        setObjectDto({ ...objectDto, fileList: list });
        sessionStorage.setItem('objectDto', JSON.stringify(objectDto));
        success(successCount + " " + t("messagesuccessuploadimage"));
    } catch (error) {
        error("Tải hình ảnh không thành công!!!");
    } finally {
        setLoading(false);
    }
};

//upload image
export const UploadFile = async (list) => {
    const body = {
        "mesgId": "CUSTOMER_MESG_00000016",
        "obj": list
    };
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    if (data.code === "1") {
        if (data.message === "1")
            return 1
        else return 0
    } else if (data === "ERR") {
        // console.log("Error at UploadFile");
        return "ERR"
    } else {
        return 0
    }
}

//email after submit
export const AfterSubmit = async (objectDto) => {
    const body = {
        "mesgId": "CUSTOMER_MESG_00000015",
        "obj": objectDto
    };
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    if (data.code === "1") {
        const jsonData = JSON.parse(data.message);
        if (jsonData === "1") {
            return 1
        } else if (jsonData === "ERR") {
            // console.log("Error at AfterSubmit")
            return "ERR"
        }
        return 0
    }
}

//submit
export const SubmitRequest = async (objectDto, setObjectDto) => {
    const body = {
        "mesgId": "CUSTOMER_MESG_00000014",
        "obj": objectDto
    };
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    if (data.code === "1") {
        const jsonData = JSON.parse(data.jsonData);
        if (jsonData === "ERR") {
            // console.log("ERROR at SubmitRequest");
            return "ERR"
        } else {
            objectDto.saved = 1;
            objectDto.checked = 0;
            setObjectDto({ ...objectDto, saved: 1 })
            sessionStorage.setItem("objectDto", JSON.stringify(objectDto));
            return 1;
        }
    } else {
        error(t("erroraccesspage"))
    }
}

//control submit
export const HandleSubmitRequest = async (objectDto, setObjectDto, listFile, setLoading, setValidate) => {
    document.body.style.overflow = 'hidden';
    if (objectDto.changePhoneChecked == 1) {
        if (objectDto.changeContactDetail[2].phoneUpDate === undefined) {
            alert('Vui lòng nhập số điện thoại liên lạc.')
            document.body.style.overflow = 'auto';
            return;
        }
        if (objectDto.changeContactDetail[2].phoneUpDate == '') {
            alert('Vui lòng nhập số điện thoại liên lạc.')
            document.body.style.overflow = 'auto';
            return;
        } else {
            if (!Service.ValidatePhone(objectDto.changeContactDetail[2].phoneUpDate, "change-phone")) {
                document.body.style.overflow = 'auto';
                return;
            }
        }
    }
    var files = [];
    if (listFile.length !== 0) {
        listFile.map(item => {
            const dataPush = {
                base64: item.base64.split("base64,").pop(),
                documentCode: item.documentCode,
                fileName: item.fileName,
                timestamp: item.timestamp,
            };
            files.push(dataPush);
        });
    }
    const addChangeFile = { ...objectDto, fileList: files };
    // setObjectDto({ ...objectDto, fileList: files })
    if (validateSubmit(addChangeFile, files, setValidate)) {
        const upload = await UploadFile(files);
        if (upload === 'ERR') {
            error(t("errormessageserver"));
        } else if (upload === 0) {
            error(t("errormessageloadimagefail"));
        } else if (upload === 1) {
            objectDto.sessionId = JSON.parse(sessionStorage.getItem("sessionId"));
            const result = await SubmitRequest(objectDto, setObjectDto);
            if (result === 1) {
                success(t("messagesuccesssendrequestlabel"));
                AfterSubmit(objectDto);
            } else {
                error(t("errormessagesendrequestfail"));
            }
        }
        window.scrollTo(0, document.body.scrollHeight);
    }
    setLoading(false);
    document.body.style.overflow = 'auto';
}

//verify before submit
export const validateSubmit = (objectDto, listFile, setValidate) => {
    var check = false;
    if (objectDto.emailNotChecked === 0) {
        if (objectDto.email === '' || objectDto.email === undefined || objectDto.email === null) {
            check = true;
        }
    }
    if (objectDto.changeContactChecked !== 1 && objectDto.changePersonalChecked !== 1 && objectDto.changeFrequencyChecked !== 1) {
        setValidate(true);
        warning(t("errormessagenotselect"));
        return false;
    }
    if (objectDto.changeContactChecked === 1) {
        if (objectDto.changeContactDetail !== undefined) {
            if (objectDto.changeAddressContactChecked === 1) {
                objectDto.changeContactDetail.map((item) => {
                    if (item.type === "CONTACT_INFO") {
                        if (item.address === '' || item.provinceCode === '' ||
                            item.provinceCode === undefined || item.districtCode === '' ||
                            item.districtCode === undefined || item.wardCode === '' ||
                            item.wardCode === undefined || (objectDto.emailNotChecked === 0 && item.emailUpDate === '')) {
                            return check = true;
                        }
                    }
                })
            }
            if (objectDto.applyFor === 0) {
                if (objectDto.changeAddressResidentChecked === 1) {
                    objectDto.changeContactDetail.map((item) => {
                        if (item.type === "RESIDENT_INFO") {
                            if (item.address === '' || item.provinceCode === '' ||
                                item.provinceCode === undefined || item.districtCode === '' ||
                                item.districtCode === undefined || item.wardCode === '' ||
                                item.wardCode === undefined) {
                                return check = true;
                            }
                        }
                    })
                }
                if (objectDto.changePhoneChecked === 1) {
                    objectDto.changeContactDetail.map((item) => {
                        if (item.type === "PHONE_CHANGE") {
                            if (item.phoneUpDate === undefined || item.phoneUpDate === "") {
                                return check = true;
                            }
                        }
                    })
                }
            }
        }
        if (objectDto.reasonDesc === '') check = true;

        if (objectDto.changeAddressContactChecked !== 1 && objectDto.changeAddressResidentChecked !== 1 && objectDto.changePhoneChecked !== 1) {
            setValidate(true);
            warning(t("errormessagecontactnotselect"));
            return false;
        }
    }
    var checkPerImg = false;
    var checkFreqImg = false;
    var checkPhoneImg = false;
    listFile.map((item) => {
        if (item.documentCode === '003') checkPerImg = true;
        if (item.documentCode === '004') checkFreqImg = true;
        if (item.documentCode === '005') checkPhoneImg = true;
    })
    if (objectDto.changePhoneChecked === 1) {
        if (objectDto.changeContactDetail.length === 0) {
            warning(t("errormessagephonenotadd"));
            setValidate(true);
            return false;
        }
        if (checkPhoneImg === false) {
            check = true;
        }
    }
    if (objectDto.changePersonalChecked === 1) {
        if (objectDto.changePersonalDetail.length === 0) {
            warning(t("errormessageprofilenotadd"));
            setValidate(true);
            return false;
        }
        if (checkPerImg === false) {
            check = true;
        }
    }
    if (objectDto.changeFrequencyChecked === 1) {
        if (objectDto.frequency === 0) {
            warning(t("errormessagefrequencynotselect"));
            setValidate(true);
            return false;
        }
        if (checkFreqImg === false) {
            check = true;
        }
    }
    setValidate(check);
    if (check) {
        warning(t("errormessagerequirefield"));
    }
    return !check
}